import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const CtrtAmendmentList = ({ ctrtObj }) => {

  const rsrc = useRsrc();

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.query = 'LATEST_AMENDMENT_BY_CODE';
    rowsReq.replaceParams = { code: ctrtObj.code };
  }, [ctrtObj.code]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    tabButtons.push(
      <TitleButton 
        dataTestId={'amend-button'} 
        icon={fas.faPlus} 
        toolTip="New Amendment"
        onClick={() => rsrc.store('md', 'CTRT_AMENDMENT_STORE_PLUGIN', { id: ctrtObj.id })}
      />
    );
  }

  return (
    <EntityList entity="CTRT" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />
  )
}